import * as React from 'react';
import { Form, Text, Select, Checkbox, TextArea } from 'react-form';
import { SingleDatePicker } from 'react-dates';
import { config } from '@src/config';
import { api } from '@src/services/api';
import {isThisUser} from 'services/user';
import { _ } from "@src/services/i18n";
import { Switch } from '@src/services/form';
import { classNames, css, mixin, vars, defaultProps, formatters } from '@src/services/theme';
import { ProtoEdit, PropsEdit, StateEdit } from '@src/components/Proto';
import { Box, Modal } from '@src/components';

// typing
interface LocalProps extends PropsEdit {
}
interface LocalState extends StateEdit {
    focused: any;
}

// style
const style = css`
    form {
        ${mixin.form}
    }
`;

// component
export class User extends ProtoEdit<LocalProps, LocalState> {

    // render
    render() {
        const loading = this.loading();
        if (loading) return null;
        const { id, onCancel } = this.props;
        const { data, values = {}, entity = null, error } = this.state;
        if (entity === null) return null;

        const locales = config.locales.map(l => ({ value: l, label: l }));

        return (
            <Modal
                title={!id ? _('new_title', 'SettingsUser') : _('edit_title', 'SettingsUser', { name: entity.email })}
                open={true}
                onClose={() => { if (onCancel) onCancel() }}
            >
                <div className={style}>
                    <Form
                        onSubmit={(v) => this.save(v)}
                        defaultValues={entity}
                    >
                        {formApi => (
                            <form
                                onSubmit={formApi.submitForm}
                            >
                                <div className="fields">
                                    <article>
                                        <label htmlFor="email">{_('field_email', 'SettingsUser')}</label>
                                        <Text field="email" id="email" className="form-control" disabled={id ? true : false} />
                                    </article>
                                    <article>
                                        <label htmlFor="first_name">{_('field_first_name', 'SettingsUser')}</label>
                                        <Text field="first_name" id="first_name" className="form-control" />
                                    </article>
                                    <article>
                                        <label htmlFor="last_name">{_('field_last_name', 'SettingsUser')}</label>
                                        <Text field="last_name" id="last_name" className="form-control" />
                                    </article>
                                    <article>
                                        <label htmlFor="address">{_('field_address', 'SettingsUser')}</label>
                                        <TextArea field="address" id="address" className="form-control" />
                                    </article>
                                    <article>
                                        <label htmlFor="locale">{_('field_locale', 'SettingsUser')}</label>
                                        <Select field="locale" id="locale" options={locales} className="form-control" />
                                    </article>
                                    {!isThisUser(entity.email) &&
                                    <article className="switch">
                                        <label htmlFor="is_read_only">{_('field_is_read_only', 'SettingsUser')}</label>
                                        <Switch field="is_read_only" id="is_read_only" className="form-control"/>
                                    </article>
                                    }
                                </div>
                                {error && this.outputError()}
                                <footer>
                                    <button type="button" className="btn btn-cancel" onClick={() => { if (onCancel) onCancel() }}>
                                        {_(`btn_cancel`, 'Settings')}
                                    </button>
                                    <button type="submit" className="btn btn-primary">
                                        {_(`btn_save`, 'Settings')}
                                    </button>
                                </footer>
                            </form>
                        )}
                    </Form>
                </div>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Settings/User.tsx